import { render, staticRenderFns } from "./op-delivery-order-modal.vue?vue&type=template&id=2fd3df24&scoped=true&"
import script from "./op-delivery-order-modal.vue?vue&type=script&lang=js&"
export * from "./op-delivery-order-modal.vue?vue&type=script&lang=js&"
import style0 from "./op-delivery-order-modal.vue?vue&type=style&index=0&id=2fd3df24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3df24",
  null
  
)

export default component.exports